import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import Link from '@nerdwallet/react-link';
import Type from '@nerdwallet/react-typography';
import { withRouter } from 'react-router';
import grnhseTrackingCheck from '../../../lib/company-content-src/grnhse-tracking-check';

import DepartmentMappings from '../../../lib/company-content-src/department-mappings';

const CompanyDepartmentsTile = ({
  slug,
  name,
  jobs,
  location,
  relativePath,
}) => (
  <div className={classNames(['departments__tile'])}>
    <Link
      href={grnhseTrackingCheck(relativePath, location.search)}
      key={name}
      color="neutral-darkest"
    >
      <div>
        {name && (
          <div>
            <Type
              size="3"
              chronicle
              className={classNames([
                'departments__header',
                classes('margin-bottom-3'),
              ])}
            >
              {name}
            </Type>
          </div>
        )}
        {DepartmentMappings[slug].body && (
          <div>
            <Type
              size="1"
              default
              className={classNames(['departments__description'])}
            >
              {DepartmentMappings[slug].body}
            </Type>
          </div>
        )}
        <div>
          <hr
            className={classNames([
              'departments__border',
              classes('border-green-light'),
              classes('margin-vertical-3'),
              classes('margin-horizontal-auto'),
              classes('margin-horizontal-0--wide'),
            ])}
          />
          <Type
            gotham
            size="1"
            color="blue-light"
            uppercase
            bold
            className={classNames(['departments__jobs'])}
          >
            {jobs.length === 1 && <span>{jobs.length} open position</span>}
            {jobs.length > 1 && <span>{jobs.length} open positions</span>}
            {jobs.length === 0 && <span>no open positions</span>}
          </Type>
        </div>
      </div>
    </Link>
  </div>
);

CompanyDepartmentsTile.defaultProps = {
  jobs: [],
};

CompanyDepartmentsTile.propTypes = {
  slug: PropTypes.string,
  name: PropTypes.string,
  jobs: PropTypes.array,
  location: PropTypes.object,
  relativePath: PropTypes.string,
};

CompanyDepartmentsTile.displayName = 'Company Departments Tile';

const CompanyDepartmentsTileWithRouter = withRouter(CompanyDepartmentsTile);

export default CompanyDepartmentsTileWithRouter;
